import * as React from 'react';
import * as moment from 'moment';
import { formatInteger } from 'helpers/common';

interface IProps {
	approveButton: any;
	title: string;
	abstract: string;
	avatarImage: any;
	userCode: string;
	addedBy: string;
	addedDate: any;
	minutesToRead: number;
	goToProfile: (code: string) => void;
	viewCount: number;
	t: (key: string, options?: any) => string;
}

/**
 *
 * @param props
 */
export const ArticleHeader = (props: IProps) => {
	return (
		<div className="articleCardHeader" id="articleHeaderHolder">
			{props.approveButton}
			<h1 className="title">{props.title}</h1>
			<h3 className="abstract">{props.abstract}</h3>
			<div className="articleAuthor">
				<div className="authorHolder">
					<div className="authorInfo">
						<div className="articleMobile">
							<p
								className="author p12"
								onClick={() => {
									props.goToProfile(props.userCode);
								}}
							>
								{props.addedBy}
							</p>
							<span className="sepDot">&#8226;</span>
							<span className="sepLine">|</span>
							<p className="date p12">{moment(props.addedDate).format('L')}</p>
							<span className="sepDot">&#8226;</span>
							<span className="sepLine">|</span>
							<p className="views p12">
								{props.viewCount} {props.viewCount === 1 ? 'view' : 'views'}
							</p>
						</div>
						<div className="minsRead">
							<span className="sepDot">&#8226;</span>
							<p className="readTime p12">
								{props.t('BSPortal_Common_MinsRead', {
									count: formatInteger(props?.minutesToRead),
								})}
							</p>
						</div>
					</div>
					<div className="clear" />
				</div>
			</div>
		</div>
	);
};
